import { Button } from "antd";

type ConfirmButtonProps = {
  onClick?: React.MouseEventHandler<HTMLElement>;
  htmlType?: "submit";
  disabled?: boolean;
}

export default function ConfirmButton(props: ConfirmButtonProps) {
  console.log("Confirm button disabled", props.disabled);
  return (
    <Button
      type="primary"
      onClick={props.disabled ? undefined : props.onClick}
      block
      size="large"
      htmlType={props.htmlType}
    >
      Confirm
    </Button>
  )
}